import { User, UserRole } from '../index';

export type UsersTableProps = {
  userRole: UserRole;
  users: Array<User>;
  onTableRowClicked: (userId: string) => void;
};

export { default as UsersTable } from './UsersTable';
